/**
 * @brief Contact 방문 / 방문예약 페이지
 * @details
 * @author hyekyoungKang
 * @date 2024-06-10
 * @version 0.0.1
 */

import React from "react";
import styles from "./Contact.module.scss";
import SubBanner from "../../components/common/subBanner/SubBanner";
import VisitReservation from "../../components/pagesComponents/common/VisitReservation";

const Contact = () => {
    return (
        <div className={styles.container}>
            <SubBanner title={"방문 예약"} hasMarginBottom={"8rem"} />
            <div className={styles.content}>
                <VisitReservation />
            </div>
        </div>
    );
};

export default Contact;
